module.exports = __webpack_public_path__ + "static/media/HOME-image3.a4d9bd38.png";